import React from 'react';
import {connect} from "react-redux";
import l10n from "../../l10n/localization";
import Loader from "../common/Loader";
import validation from '../../validation/commodityGroup';
import Validate from 'validate.js';
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";
import * as commodityGroupActions from "../../actions/commodityGroup";

class CommodityGroupForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item.item : null,
            schema: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        title: l10n.commodities.name,
                    },
                }
            },
            uiSchema: {
                name: {
                    "ui:emptyValue": ""
                },
            },
            fields: {},
            isDirty: false,
            formData: utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item.item : null
        }
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    this.props.dispatch(commodityGroupActions.edit(form));
                })
            } else {
                this.setState({item: formData}, () => {
                    this.props.dispatch(commodityGroupActions.edit(form));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                this.props.dispatch(commodityGroupActions.add(form));
            })
        }
        this.setState((state) => {return {...state, isDirty: false, formData: formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleError = () => {
        this.props.dispatch(commodityGroupActions.errorMessage(l10n.validation.form_error));
    };

    render() {
        let formClassName = (this.state.isDirty) ? 'commodity-group-form dirty':'commodity-group-form';

        if (this.props.loading || this.props.saving) {
            return (<div><Loader /></div>)
        }

        return (
            <div className={formClassName}>
                <h1>Commodity Group</h1>
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.state.formData}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onSubmit={this.onSubmit}
                    onError={this.handleError}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    fields={this.state.fields} >
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.commodityGroup.loading,
        saving: state.commodityGroup.saving,

        newlyCreatedElement: state.creation.newlyCreatedCommodityGroup,
    });
})(CommodityGroupForm);



// WEBPACK FOOTER //
// ./src/components/forms/CommodityGroupForm.js